import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CreateEmpresaRequest } from '@models/empresa/createEmpresaRequest.model';
import { EmpresaDto } from '@models/empresa/empresaDto.model';
import { UpdateEmpresaRequest } from '@models/empresa/updateEmpresaRequest.model';
import { CreateEmpresaUsuarioRequest } from '@models/empresaUsuario/createEmpresaUsuarioRequest.model';
import { EmpresaUsuarioDto } from '@models/empresaUsuario/empresaUsuarioDto.model';
import { EmpresaUsuarioSummaryDto } from '@models/empresaUsuario/empresaUsuarioSummaryDto.model';
import { UpdateEmpresaUsuarioRequest } from '@models/empresaUsuario/updateEmpresaUsuarioRequest.model';
import { UsuarioFilter } from '@models/usuario/usuarioFilter.model';
import { UsuarioSummaryDto } from '@models/usuario/usuarioSummaryDto.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class EmpresaUsuarioService {

  constructor(private http: HttpClient) { }


  create(createEmpresaUsuarioRequest: CreateEmpresaUsuarioRequest): Observable<CreateResponseBase> {
    return this.http.post<CreateResponseBase>("/api/EmpresaUsuario/Create", createEmpresaUsuarioRequest);
  }

  update(updateEmpresaUsuarioRequest: UpdateEmpresaUsuarioRequest): Observable<any> {
    return this.http.put<any>("/api/EmpresaUsuario/Update", updateEmpresaUsuarioRequest);
  }

  setEmpresaPredeterminada(): Observable<any> {
    return this.http.put<any>("/api/EmpresaUsuario/SetEmpresaPredeterminada", null);
  }

  actualizarRolUsuarioEmpresa(idUsuario: number, idRolEmpresa: number): Observable<any> {
    return this.http.put<any>("/api/EmpresaUsuario/ActualizarRolUsuarioEmpresa?idUsuario=" + idUsuario + "&idRolEmpresa=" + idRolEmpresa, null);
  }


  getAll(): Observable<EmpresaUsuarioDto[]> {
    return this.http.get<EmpresaUsuarioDto[]>("/api/EmpresaUsuario/GetAll");
  }

   getAllUsuariosSummaryByEmpresa(): Observable<EmpresaUsuarioSummaryDto[]> {
    return this.http.get<EmpresaUsuarioSummaryDto[]>("/api/EmpresaUsuario/GetAllUsuariosSummaryByEmpresa");
  }

  getById(id: number): Observable<EmpresaUsuarioDto> {
    return this.http.get<EmpresaUsuarioDto>("/api/EmpresaUsuario/GetById?id=" + id);
  }

  getAllByFilter(usuarioFilter: UsuarioFilter): Observable<EmpresaUsuarioDto[]> {
    return this.http.post<EmpresaUsuarioDto[]>("/api/EmpresaUsuario/GetAllByFilter", usuarioFilter);
  }

  getAllUsuariosByEmpresa(idUsuario: number): Observable<EmpresaUsuarioDto> {
    return this.http.get<EmpresaUsuarioDto>("/api/EmpresaUsuario/GetAllUsuariosByEmpresa?idUsuario=" + idUsuario);
  }

  getAllEmpresasByUsuario(idEmpresa: number): Observable<EmpresaUsuarioDto> {
    return this.http.get<EmpresaUsuarioDto>("/api/EmpresaUsuario/GetAllEmpresasByUsuario?idEmpresa=" + idEmpresa);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/EmpresaUsuario/Delete?id=" + id);
    else
      return of(null)
  }

  deleteLogic(id: number): Observable<any> {
    return this.http.delete<any>("/api/EmpresaUsuario/DeleteLogic?id=" + id);
  }
}
